<aside>
  <ng-container *ngIf='tablet$ | async'>
    <button class='btn btn-link side-nav-mobile-close' (click)='navCloseClick.emit( $event )'>
      <i class='fa fa-times'></i>
    </button>
  </ng-container>
  <div class='side-nav-scroll-container' #navScroll>
    <h6 class='side-nav-title'>{{ navTitle }}</h6>
    <ul class='side-nav'>
      <ng-container *ngIf='enabledSectionIds && enabledSectionIds.length;else placeholder'>
        <ng-container *ngFor='let section of availableSections;let i = index;trackBy trackByKey'>
          <li class='side-nav-item' *ngIf='section.alwaysShow || enabledSectionIds?.includes( section.key )'
            mrt-side-nav-item [key]='section.key' [index]='i'>
            <a (click)='navLinkClick( $event, section )' href='#{{section.key}}' target='_self' class='side-nav-link'
              [ngClass]='{ active: activeSection === section.key }'
              [attr.disabled]='!enabledSectionIds?.includes( section.key ) ? true : null'>
              <span><img class='side-nav-icon' [src]='section.iconURL'
                  alt="{{ (section.labels && section.labels[type]) || section.label }}" /></span>
              <span class='side-nav-label'>
                <span class='side-nav-label-text'>{{ (section.labels && section.labels[type]) || section.label }}</span>
                <span class='beta-tag' *ngIf='section.beta'>Beta</span>
                <span class='coming-soon-tag' *ngIf='section.comingSoon'>Coming Soon</span>
              </span>
              <i *ngIf='!hasPermissions( section.permissions )' class='side-nav-lock fa fa-lock'></i>
            </a>
          </li>
        </ng-container>
      </ng-container>
    </ul>

    <div class="text-center mt-3 mb-4" *ngIf="!hideChangeLog">
      <app-changelog-btn (showChangelog)="showChangelogClick.emit( $event )">
      </app-changelog-btn>
    </div>

    <div class="text-center meta-item mt-3">
      <div>Read About Our Methodology</div>
      <a class="btn btn-primary meta-link text-light rounded"
        href="https://info.pixalate.com/publisher-trust-index-methodology" target="_blank">
        Click here
      </a>
    </div>

    <div class="text-center meta-item mt-3">
      <div>Want to Improve Your Publisher Score?</div>
      <a class="btn btn-primary meta-link text-light rounded"
        href="https://www.pixalate.com/blog/publisher-request-reevaluation-mrt" target="_blank">
        Learn more
      </a>
    </div>
  </div>
</aside>

<ng-template #placeholder>
  <li class='side-nav-item'>
    <div class='side-nav-placeholder'>
      <span class='side-nav-placeholder-icon'></span>
      <span class='side-nav-placeholder-label' style='width:80px'></span>
    </div>
  </li>
  <li class='side-nav-item'>
    <div class='side-nav-placeholder'>
      <span class='side-nav-placeholder-icon'></span>
      <span class='side-nav-placeholder-label' style='width:120px'></span>
    </div>
  </li>
  <li class='side-nav-item'>
    <div class='side-nav-placeholder'>
      <span class='side-nav-placeholder-icon'></span>
      <span class='side-nav-placeholder-label'></span>
    </div>
  </li>
</ng-template>